/**
 * Active time calculation utility.
 * Computes active engagement time by summing intervals between consecutive
 * timestamps, excluding gaps that exceed the inactivity threshold.
 */

/** Inactivity threshold in seconds. Gaps larger than this are excluded. */
const INACTIVITY_THRESHOLD_SECONDS = 120;

/**
 * Calculates active time from an ordered sequence of activity timestamps.
 * Sums intervals between consecutive timestamps where the gap is ≤ 120 seconds.
 * Gaps exceeding 120 seconds are considered inactivity and are excluded.
 *
 * @param timestamps - Ordered array of activity timestamps (in seconds, monotonically increasing)
 * @returns Total active time in seconds
 */
export function calculateActiveTime(timestamps: number[]): number {
 if (timestamps.length < 2) {
  return 0;
 }

 let activeTime = 0;

 for (let i = 1; i < timestamps.length; i++) {
  const gap = timestamps[i] - timestamps[i - 1];
  if (gap <= INACTIVITY_THRESHOLD_SECONDS) {
   activeTime += gap;
  }
 }

 return activeTime;
}
